import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";

export default function PageHeader({ overline, title, subtitle, accent }) {
  const { t } = useLang();
  const accentText = accent || t("common.brand");
  return (
    <header className="page-header-band pt-28 pb-10 md:pt-40 md:pb-16">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <nav className="flex flex-wrap items-center gap-2 text-[10px] md:text-xs font-mono uppercase tracking-widest text-[#7B8AA0] mb-5 md:mb-6">
          <Link to="/" className="hover:text-[#1E3A5F]">{t("pages.breadcrumbHome")}</Link>
          <CaretRight size={12} weight="bold" />
          <span className="text-[#1E3A5F]">{overline}</span>
        </nav>
        <p className="overline-maroon mb-3 md:mb-4">{accentText}</p>
        <h1 className="font-serif-display font-light text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight text-[#0F1E33] leading-[1.05]">
          {title}
        </h1>
        <div className="hairline-gold w-20 md:w-24 mt-5 md:mt-6" />
        {subtitle && (
          <p className="mt-5 md:mt-6 max-w-2xl text-[#1F2D40] text-base md:text-lg leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </header>
  );
}
